import React, { Component } from 'react';
import { FormGroup, FormControl, Image}  from 'react-bootstrap';
import {Card, CardText } from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import Checkbox from 'material-ui/Checkbox';
import FlatButton from 'material-ui/FlatButton'
import mozak from '../../assets/mozak.png';
import screens from '../../assets/screens.png';
import play from '../../assets/play_store.png';
import app from '../../assets/app_store.png';
import { connect } from 'react-redux';
import { loginUser, fieldChanged } from './auth_actions';

class Login extends Component {
  constructor(){
    super();
    this.state={
      login: true
    }
  }

  handleFieldChange = key => event => {
    console.log(event.target.value)
    this.props.fieldChanged(key,event.target.value)
  }

  handleLoginRealtor = () => {
    const { email, password } = this.props;
    this.props.loginUser( email, password, true );
  }

  handleLoginVA = () => {
    const { email, password } = this.props;
    this.props.loginUser( email, password, false );
  }

  render() {
    return (
      <div>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: 60}}>
            <div style={{ marginLeft: 20, marginTop: 60 }}>
              {this.renderLoginForm()}
            </div>
        </div>
        
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', margin: 40}}>
            <a href="https://www.mymozak.com/press.html" style={{ color: 'black', margin: 10 }}>PRESS</a>
            <a href="https://www.mymozak.com/terms.html" style={{ color: 'black', margin: 10 }}>TERMS</a>
            <a href="https://www.mymozak.com/policy.html" style={{ color: 'black', margin: 10 }}>PRIVACY</a>
            <a href="https://mozak.recruitee.com/" style={{ color: 'black', margin: 10 }}> CAREERS </a>
            <a style={{ color: 'black', margin: 10, fontSize: 10 }} >COPYRIGHT © 2018. ALL RIGHTS RESERVED. MOZAK</a>
        </div>

      </div>
    )
  }

  renderButton() {
    if (this.props.loading) {
      return <p> Loading...</p>
    } else {
      return (
        <span style={{ display: 'flex', justifyContent: 'center'}}>
        <RaisedButton onClick={this.handleLoginVA} primary label="VA Login" fullWidth={false} />
        &nbsp;
        <RaisedButton onClick={this.handleLoginRealtor} primary label="Realtor Login" fullWidth={false} />
        </span>
      )
    }
  }

  renderLoginForm() {
      return (
        <div>
          <Card
            style={{
              backgroundColor: 'white',
              width: 380,
              height: 400,
              paddingTop: 50,
              paddingLeft: 20,
              paddingRight: 20
            }}>

          <CardText>
            <div
              style={{display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <img src={mozak} style={{ width: 250}} alt="mozak"/>
            </div>
            <br />
            <br />
              <FormGroup bsSize="lg">
                <FormControl placeholder="Username" value={this.props.email} onChange={this.handleFieldChange('email')}/>
              </FormGroup>
              <FormGroup bsSize="lg">
                <FormControl type="password" placeholder="Password" value={this.props.password} onChange={this.handleFieldChange('password')} />
              </FormGroup>
              <p style={{ color: 'red', textAlign: 'center'}}>{this.props.error}</p>
              <br />
                {this.renderButton()}
          </CardText>
        </Card>
      </div>
    )
  }
}

const mapStateToProps = ({auth}) => {
  const { email, password, error, checked, loading }  = auth;
  return { email, password, error, checked, loading };
};

const mapDispatchToProps = dispatch => {
  return {
    fieldChanged:(key,value) => dispatch(fieldChanged(key,value)),
    loginUser:(email, password, checked) => dispatch(loginUser(email, password, checked)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/auth/auth.js